
const videos = {

    // init() {
    //     document.addEventListener("click", function (e) {
    //         const trigger = e.target.closest(".js-video-home");
    //
    //         if (!trigger || trigger.classList.contains("_loaded")) {
    //             return;
    //         }
    //
    //         this.stop();
    //         const videoId = trigger.getAttribute("data-video-id");
    //         const iframeWrap = trigger.querySelector("._iframe");
    //
    //         if (!videoId || !iframeWrap) {
    //             return;
    //         }
    //
    //         iframeWrap.innerHTML = `
	// 	<iframe
	// 		src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1"
	// 		title="Vidéo de présentation"
	// 		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
	// 		allowfullscreen
	// 	></iframe>
	// `;
    //
    //         trigger.classList.add("_loaded");
    //     });
    //
    // },
    init() {
        document.addEventListener("click", (e) => {
            const trigger = e.target.closest(".js-video-home");

            if (!trigger || trigger.classList.contains("_loaded")) {
                return;
            }

            this.stop(); // ✅ fonctionne maintenant

            const videoId = trigger.getAttribute("data-video-id");
            const iframeWrap = trigger.querySelector("._iframe");

            if (!videoId || !iframeWrap) return;

            iframeWrap.innerHTML = `
            <iframe
                src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        `;

            trigger.classList.add("_loaded");
        });
    },
    stop(container=document) {
        const videos = container.querySelectorAll('.js-video-home._loaded');

        videos.forEach(video => {
            const iframeWrap = video.querySelector('._iframe');
            if (iframeWrap) {
                iframeWrap.innerHTML = ''; // 🔥 STOP réel
            }
            video.classList.remove('_loaded');
        });
    }
};

export default videos;
